/************
 * Developed by : Shiva Software Solutions
 * Date : 24-02-2025
 * Descriptions : Route for MRD Report page
 ************/
import React from 'react';
import {authRole} from '../../shared/constants/AppConst';

export const mrdReportConfig = [
  //Redirect to MRD Report page
  {
    auth: authRole.admins,
    routes: [
      {
        path: '/mrdLabReports',
        component: React.lazy(() =>
          import('../clientDashboard/appointment/Tabs/mrdLabReport'),
        ),
      },
    ],
  },
];
